// extracted by mini-css-extract-plugin
export default {"form":"Checkout_form__WWFFx","control":"Checkout_control__CZS16","actions":"Checkout_actions__Bhrd2","submit":"Checkout_submit__g6-hN","invalid":"Checkout_invalid__TUbD7"};